module.exports = __webpack_public_path__ + "img/hasfild.1f4e924e.png";